var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRemoveDocAdmin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.311,
    height: 16.3,
    viewBox: "0 0 13.311 16.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "remove",
    transform: "translate(0.158 0.15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19512",
    "data-name": "Path 19512",
    d: "M1.061,4.762v9.232a2.067,2.067,0,0,0,.55,1.426A1.845,1.845,0,0,0,2.949,16h7.09a1.845,1.845,0,0,0,1.339-.579,2.067,2.067,0,0,0,.55-1.426V4.762a1.431,1.431,0,0,0-.367-2.815H9.642V1.479A1.472,1.472,0,0,0,8.158,0H4.831a1.472,1.472,0,0,0-1.484,1.48v.468H1.428a1.431,1.431,0,0,0-.367,2.815Zm8.978,10.487H2.949A1.187,1.187,0,0,1,1.81,13.994v-9.2h9.368v9.2a1.187,1.187,0,0,1-1.139,1.255ZM4.1,1.479A.722.722,0,0,1,4.831.748H8.158a.722.722,0,0,1,.734.731v.468H4.1ZM1.428,2.7H11.56a.674.674,0,0,1,0,1.349H1.428a.674.674,0,1,1,0-1.349Zm0,0",
    transform: "translate(0.003 0.002)",
    fill: "#c6c6c6",
    stroke: "#c6c6c6",
    strokeWidth: 0.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveDocAdmin);
export default __webpack_public_path__ + "static/media/removeDocAdmin.1745c8e4cd2da9ce82f267a4657fb834.svg";
export { ForwardRef as ReactComponent };